module.exports = __webpack_public_path__ + "static/NHaasGroteskTXStd-55Rg-fab6feb8c0c1b40344b5f81c3b2fb637.woff2";